module.exports = __webpack_public_path__ + "img/DISH-Portable-Satellite-Antenna-Options.0e9571f5.jpg";